module.exports = __webpack_public_path__ + "static/media/logo-mark.06a5ea1a.svg";